import TrashIndicator from './component'

export default TrashIndicator
